"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const gameWidth = 320;
exports.default = gameWidth;
